import { HttpContextToken } from '@angular/common/http';

export const SIGNAGE_API = new HttpContextToken<boolean>(() => false);
export const TOKEN_ENDPOINT = new HttpContextToken<boolean>(() => false);
